import { LoadingSpinner } from "shared/ui/spinners/loading-spinner";

export const VerifyingStep = () => (
  <div className="flex min-h-[300px] flex-col items-center justify-center">
    <LoadingSpinner className="mb-4" />
    <p className="text-center typography-body-4">
      Checking meeting taker's calendar for booked meeting...
    </p>
    <p className="mt-2 text-center text-base-content/60 typography-body-5">
      This may take a few seconds
    </p>
  </div>
);
